import React, { createContext, FC, useCallback, useContext, useState } from 'react';
import { generateRandomGuid4 } from '../../../monitoring/utils';

// A map of item ids to their respective search info
type SearchMetaInfo = Record<string, { sectionName: string; sectionIndex: number; itemIndexWithinCategory: number }>;

export const SearchResultsBIContext = createContext<{
  searchId?: string;
  setNewSearchId: () => string;
  searchMetaInfo?: SearchMetaInfo;
  setSearchMetaInfo: (x: SearchMetaInfo) => void;
  resetSearchBI: () => void;
}>({
  setNewSearchId: () => 'this00is-an00-0000-0000-invalid000id',
  setSearchMetaInfo: () => {},
  resetSearchBI: () => {},
});

export const SearchResultsBIProvider: FC = ({ children }) => {
  const [searchId, setSearchId] = useState<string>();

  const setNewSearchId = useCallback(() => {
    const newSearchId = generateRandomGuid4();
    setSearchId(newSearchId);
    return newSearchId;
  }, [setSearchId]);

  const [searchMetaInfo, setSearchMetaInfo] = useState({});

  const resetSearchBI = useCallback(() => {
    setSearchMetaInfo({});
    setSearchId(undefined);
  }, []);

  return (
    <SearchResultsBIContext.Provider
      value={{ searchMetaInfo, setSearchMetaInfo, searchId, setNewSearchId, resetSearchBI }}
    >
      {children}
    </SearchResultsBIContext.Provider>
  );
};

export const useSearchResultsBI = () => useContext(SearchResultsBIContext);
